var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostOrVideoFeed',{attrs:{"user-id":_vm.userId,"type":"post"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_c('Post',{attrs:{"untyped-item":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }